module.exports = "/dist/525d5b452809b3172a2a34e26d9db546.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700.woff
// module id = 160
// module chunks = 0